module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAaCAYAAAC6nQw6AAAAAXNSR0IArs4c6QAAAShJREFUSEvtla1PxEAUxGdamvAHIEkQeCxYBAISzG4NQfERcGhQnAONg/DhTm1bAcEgsJzFI0iQeEhKO2SbHALoNdfDcSv3vfntZrI7jwDgnFsl2QEwJ2nC7zUtkh8AHkkeGmNumGXZclEUt03CQfUwDFfonHsAMD8KCEDPg94ATJL0wKchgbOSFgC8e5BIdq2160NCqnbnXBfAWh+0ba29aANKkmRL0nkFCoJg0xhz1QaUpulGWZaXY1C9e2OPml/Wf/EIwEEcx8fNjvzscM7tAzjq//7XIAj22uRRWZYnkqYqUJubfNcMBJF8jqJo0YvyPL+XNFN36FfU/tZA8sxau+trSZKcStqpAVVRWxv+JF8kLXkxyTtJ0zWg3t+No1EHpKROHMfXn5VUAZqzzreFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.png
// module id = JhOT
// module chunks = 0